import { CheckpointDto } from '../state';

export type ImportProgressStatus = 'WAIT' | 'SUCCESS' | 'FAIL' | 'READY';

export interface ImportProgress {
  name: string;
  status: ImportProgressStatus;
  message: string;
}

type ImportReducerState = {
  status: 'PROCESSING';
  checkpoints: CheckpointDto[];
  importProgress: ImportProgress[];
  currentCheckpoint: number;
} | {
  status: 'COMPLETE' | 'PENDING';
  checkpoints: CheckpointDto[];
  importProgress: ImportProgress[];
  currentCheckpoint?: undefined;
};

export const initialState: ImportReducerState = { status: 'PENDING', checkpoints: [], importProgress: [] };

type ImportReducerAction = {
  type: 'START';
  checkpoints: CheckpointDto[];
} | {
  type: 'CANCEL';
} | {
  type: 'UPDATE_PROGRESS';
  id: number;
  success: true;
} | {
  type: 'UPDATE_PROGRESS';
  id: number;
  success: false;
  message: string;
};

function checkpointToStatus(checkpoint: CheckpointDto): ImportProgress {
  return {
    message: '',
    name: checkpoint.name,
    status: 'WAIT'
  };
}

export function bulkImportReducer(state: ImportReducerState, action: ImportReducerAction): ImportReducerState {

  switch (action.type) {
    case 'START':
      if (state.status !== 'PENDING') {
        throw Error('Job can only be started from pending state');
      }
      if (action.checkpoints.length === 0) {
        throw Error('Cannot start no checkpoints specified');
      }

      const importProgress = action.checkpoints.map(checkpointToStatus);
      importProgress[0].status = 'READY';
      return {
        checkpoints: action.checkpoints,
        currentCheckpoint: 0,
        importProgress,
        status: 'PROCESSING'
      };
    case 'CANCEL':
      return { ...initialState };
    case 'UPDATE_PROGRESS':
      // Progress updates may come in after canellation
      if (state.status === 'PENDING') {
        return state;
      }
      if (action.id >= state.checkpoints.length) {
        throw Error(`Update ${action.id} out of range length ${state.checkpoints.length}`);
      }
      if (state.importProgress[action.id].status !== 'READY') {
        throw Error('Cannot update checkpoint not in ready state ');
      }

      const newState = { ...state };
      const updatedStatus = newState.importProgress[action.id];

      newState.importProgress[action.id] = {
        ...updatedStatus,
        message: action.success ? '' : action.message,
        status: action.success ? 'SUCCESS' : 'FAIL'
      };

      if (newState.status === 'PROCESSING') {
        const nextCheckpoint = newState.currentCheckpoint + 1;

        if (nextCheckpoint === newState.checkpoints.length) {
          return {
            ...newState,
            currentCheckpoint: undefined,
            status: 'COMPLETE'
          };
        } else {

          newState.importProgress[nextCheckpoint].status = 'READY';
          return {
            ...newState,
            currentCheckpoint: nextCheckpoint
          };
        }
      }

      return newState;

    default:
      throw new Error('Unknown action');
  }
}
